import { defineComponent, ref, Ref, computed, inject } from 'vue';
import { LocationModel, LocationStatus, ILocationManager } from '@truckdown/locations';
import { locationKey, locationUpdateKey } from '../keys';
import context from '@truckdown/components-systems';

interface IData {
    editLocation: Ref<LocationModel>;
}

const getInitialData = (): IData => {
    const injectedLocation = inject<Ref<LocationModel>>(locationKey)!;
    return {
        editLocation: injectedLocation,
    };
};

const getComputed = function (data: IData, props: any) {
    return {
        locationStatus: computed(() => {
            //return data.editLocation.value.status == LocationStatus.PendingApproval ? "Pending" : LocationStatus[data.editLocation.value.status];
            switch (data.editLocation.value.status) {
                case LocationStatus.PendingApproval:
                    return "Pending Approval";
                case LocationStatus.Active:
                    if (data.editLocation.value.subscriptions[props.selectedSite]) {
                        return data.editLocation.value.subscriptions[props.selectedSite].tagName.replace(/#/g, "").toUpperCase();
                    } else {
                        return "Not Published"
                    }
                default:
                    return LocationStatus[data.editLocation.value.status];
            }
        }),
        statusStyle: computed(() => {
            switch (data.editLocation.value.status) {
                case LocationStatus.PendingApproval:
                    return "status-badge td-badge primary slim"
                case LocationStatus.Active:
                    if (data.editLocation.value.subscriptions[props.selectedSite]) {
                        let tag = data.editLocation.value.subscriptions[props.selectedSite].tagName.replace(/#/g, "").toLowerCase();
                        if (tag) {
                            return `status-badge td-badge slim ${tag}-background ${props.selectedSite}`
                        }
                        return "status-badge td-badge slim"
                    } 
                case LocationStatus.Purge:
                    return "status-badge td-badge danger slim"
                default:
                    return "status-badge td-badge slim"
            }
        }),
    };
}

const getMethods = (data: IData ) => {
    const updateLocation = inject<(value: LocationModel) => void>(locationUpdateKey)!;
    return {
       
        changeStatus: async function (status: LocationStatus) {
            const manager = await context.getService<ILocationManager>('ILocationManager');
            try {

                if (data.editLocation.value) {
                    let updateStatusModel = {
                        locationId: data.editLocation.value.id,
                        status: status
                    }
                    let result = await manager.updateStatus(updateStatusModel);
                    if (result && result.ok) {
                        data.editLocation.value.status = status;
                        updateLocation(data.editLocation.value);
                        return true;
                    } else {
                        return false;
                    }
                }
            } catch (error) {
                console.error('Listing Status Change Failed:', error);
            }
            return false;
        }
    };
};

export default defineComponent({
    name: "ListingStatus",
    props: {
        isAdmin: Boolean,
        editState: Boolean,
        selectedSite: String
    },
    setup: function (props, ctx) {
        var data = getInitialData();
        var methods = getMethods(data);
        var computed = getComputed(data, props);

        return {
            ...data,
            ...computed,
            ...methods,
            'LocationStatus': LocationStatus
        }
    }
});